interface ITrashIconProps extends React.SVGProps<SVGSVGElement> {
  onClick?: () => void;
  hoverBackground?: string;
}

export const TrashIcon: React.FC<ITrashIconProps> = (props) => {
  const svg = (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox={props.viewBox ?? "0 0 24 24"}
      fill={props.fill ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5H21"
        stroke={props.stroke ?? "#E40031"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
      <path
        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
        stroke={props.stroke ?? "#E40031"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
      <path
        d="M10 11V17"
        stroke={props.stroke ?? "#E40031"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
      <path
        d="M14 11V17"
        stroke={props.stroke ?? "#E40031"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
    </svg>
  );

  if (!props.onClick) return svg;

  return (
    <span
      role="button"
      aria-label="Delete"
      tabIndex={0}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          props.onClick?.();
        }
      }}
      style={{
        display: "inline-flex",
        cursor: "pointer",
        padding: 2,
        borderRadius: 6,
        transition: "background 0.15s, box-shadow 0.15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = props.hoverBackground ?? "#FFE5E5";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {svg}
    </span>
  );
};
